import * as React from 'react';
import { LikeOrWatchGuest, LikeOrWatchPremium, LikeOrWatchFreePlan } from './LikeOrWatch';

function LikeOrWatchOption({data} :any) {
  const user_state = data.user_state;

  if (user_state?.status == 'guest') {
    return <LikeOrWatchGuest />;
  } else if (user_state?.status == 'premium') {
    return <LikeOrWatchPremium id={data.ticker} stock_in_favorites={user_state?.stock_in_favorites} new_watchlists={user_state?.watchlists} />;
  } else if (user_state?.status == 'free_plan') {
    return <LikeOrWatchFreePlan />;
  } else {
    return <span/>
  }
}

function Price({data} :any) {
  return (
    <div className="col-lg-4 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">{data.ticker} <span className={ (data.delisted == true) ? 'badge-danger badge-pill' : ''}>{ (data.delisted == true) ? 'Delisted' : ''}</span></h4>
          <p className="card-description">
            < LikeOrWatchOption data={data} />
          </p>
          <p className="card-description"> Quote (USD)</p>
          <div className="table-responsive">
            <table className="table table-striped">
              <tbody>
                <tr>
                  <td>Latest Price</td>
                  <td>{data.latest_price}</td>
                </tr>
                <tr>
                  <td>Change</td>
                  <td>{data.change}</td>
                </tr>
                <tr>
                  <td>Change Percent</td>
                  <td style={{ color: data.change_percent_color }}><strong>{data.change_percent}</strong></td>
                </tr>
                <tr>
                  <td>Open</td>
                  <td>{data.open}</td>
                </tr>
                <tr>
                  <td>low</td>
                  <td>{data.low}</td>
                </tr>
                <tr>
                  <td>High</td>
                  <td>{data.high}</td>
                </tr>
                <tr>
                  <td>Previous Close</td>
                  <td>{data.previous_close}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Price;
